import { BaseObject } from '@ootk/src/main';
export class ControlSite extends BaseObject {
    TStop;
    linkAehf;
    linkWgs;
    linkIridium;
    linkGalileo;
    linkStarlink;
    constructor(info) {
        super(info);
        Object.keys(info).forEach((key) => {
            this[key] = info[key];
        });
    }
    isLandObject() {
        return true;
    }
    isStatic() {
        return true;
    }
}
